const ChemicalReconciliationListing = () =>
  import(
    "../../components/chemtracker/chemical_inventory_reconciliation/ReconciliationListing.vue"
  );

const routes = [
  {
    path: "/raft/chemtracker/reconciliation/history",
    component: ChemicalReconciliationListing,
    name: "ReconciliationHistory",
  },
  {
    path: "/node/:groupNid(\\d+)/chemtracker/reconciliation-history",
    component: ChemicalReconciliationListing,
    name: "groupReconciliationHistory",
    props: true,
  },
];

const globalComponents = { ChemicalReconciliationListing };

export {
  routes as chemicalReconciliationHistoryRoutes,
  globalComponents as chemicalReconciliationHistoryGlobalComponents,
};
